import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function deleteOptionPrice(ids: number[]) {
  return restApiClient.url(encodeNestedObject(API.optionPrices.delete.url, { ids })).delete()
}
